import { render, staticRenderFns } from "./attainment.vue?vue&type=template&id=12af6634"
import script from "./attainment.vue?vue&type=script&lang=js"
export * from "./attainment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports